var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-list',{attrs:{"loading-count":_vm.loadingCount,"sort-by":"fragmentId","items":_vm.value},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('fragment-box',{key:item._id,attrs:{"balance":_vm.fragmentBoxesBalance ? _vm.fragmentBoxesBalance[item.fragmentId] : 0,"value":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }